/**
 * Keys for app_settings table (global settings, set by admins/broadcasters).
 * Values apply to all users so listings appear the same for everyone.
 */
export const APP_SETTINGS_TV_LISTINGS_DAYS_KEY = 'tv_listings_days'

/** When 'true', programmes with "Signed" in title are marked BSL in the TV guide for all users. Set by broadcasters on profile. */
export const APP_SETTINGS_SIGNED_TITLE_KEY = 'tv_accessibility_include_signed_title'

/** When 'true', version (commit + date) is shown in the header for moderators and admins. Global feature flag; set in Admin → Feature flags. */
export const APP_SETTINGS_HEADER_SHOW_VERSION_KEY = 'header_show_version'

/** When 'true', broadcaster and ad-creator (vendor) groups appear in the main Groups feed and in join-group lists. When 'false', only community groups are shown. Set in Admin → Feature flags. */
export const APP_SETTINGS_GROUPS_FEED_SHOW_VENDOR_GROUPS_KEY = 'groups_feed_show_vendor_groups'

/** When 'true', signed programmes are identified in TV listings (BSL from accessibility uploads and "Signed:" title). When 'false', signed/BSL detection is skipped and the BSL filter is hidden on the Listings screen. Set in Admin → Feature flags. */
export const APP_SETTINGS_LISTINGS_SHOW_SIGNED_PROGRAMS_KEY = 'tv_listings_show_signed_programs'

/** Days of catalogue visibility from start of today UTC when ingesting streaming CSV (same window idea as TV listings). Stored value e.g. "7". */
export const APP_SETTINGS_STREAMING_CATALOGUE_WINDOW_DAYS_KEY = 'streaming_catalogue_window_days'

/** When 'true', newly registered users are auto-confirmed so they can sign in without email verification. Use when Supabase has email confirmation enabled but you want to bypass it. Set in Admin → Feature flags. */
export const APP_SETTINGS_EMAIL_VERIFICATION_BYPASS_KEY = 'email_verification_bypass'

/** JSON array of Google Drive inbox folders for Refresh listings (see listingsFolderConfig.ts). */
export { APP_SETTINGS_N8N_LISTINGS_FOLDERS_KEY as APP_SETTINGS_N8N_LISTINGS_FOLDERS_KEY } from '@/lib/listingsFolderConfig'
export { APP_SETTINGS_N8N_PROCESSED_FOLDER_KEY as APP_SETTINGS_N8N_PROCESSED_FOLDER_KEY } from '@/lib/listingsFolderConfig'
export { APP_SETTINGS_LISTINGS_MANAGEMENT_V2_KEY as APP_SETTINGS_LISTINGS_MANAGEMENT_V2_KEY } from '@/lib/listingsFolderConfig'

/** Query key for app settings (invalidate after admin/broadcaster update so Profile and TV data refetch). */
export const APP_SETTINGS_QUERY_KEY = ['app-settings'] as const

export const LISTINGS_MANAGEMENT_DASHBOARD_QUERY_KEY = ['listings-management-dashboard'] as const
export const N8N_INGEST_RUNS_QUERY_KEY = ['n8n-ingest-runs'] as const
